"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapFilters = void 0;
var FilterType_1 = require("./FilterType");
var MapFilters = /** @class */ (function () {
    function MapFilters() {
        var _this = this;
        this.OgcFilter = null;
        this.CqlFilter = null;
        this.hasFilter = function (filterOpts) {
            var self = _this;
            var filterValues;
            var hasFilter = false;
            switch (filterOpts.filterType) {
                case FilterType_1.FilterType.Ogc:
                    filterValues = self.OgcFilter.filters;
                    break;
                case FilterType_1.FilterType.Cql:
                    filterValues = self.CqlFilter.filters;
                    break;
            }
            if (filterValues !== null) {
                filterOpts.filters.forEach(function (value) {
                    if (filterValues.hasFilter(value) === true) {
                        hasFilter = true;
                    }
                });
            }
            return hasFilter;
        };
    }
    return MapFilters;
}());
exports.MapFilters = MapFilters;
//# sourceMappingURL=MapFilters.js.map